export default "__VITE_ASSET__Dhr3H6YW__"